import AsyncStorage from '@react-native-async-storage/async-storage';
import { AsyncStorageWrapper, CachePersistor } from 'apollo3-cache-persist';
import type { NormalizedCacheObject } from '@apollo/client';
import { env } from '@/lib/env';
import { createApolloClient } from '@/lib/apollo/createApolloClient';

export const apolloClient = createApolloClient({
  httpUri: env.graphqlHttpUri,
});

/**
 * Persist the Apollo cache to disk (via AsyncStorage — the app's cross-platform
 * KV layer, so this works on native and web) so cold starts show recently-seen
 * data (e.g. meal search results) instantly instead of always re-fetching.
 *
 * Auth tokens are NOT in the Apollo cache (they live in `persistentStorage`), so
 * nothing secret is written here. `maxSize: false` keeps the persistor from
 * silently purging entries, which would defeat the "appears instantly" goal; the
 * normalized cache stays small and is evicted where staleness matters (e.g. the
 * `meals` field on custom-food save).
 */
export const cachePersistor = new CachePersistor<NormalizedCacheObject>({
  cache: apolloClient.cache,
  storage: new AsyncStorageWrapper(AsyncStorage),
  debug: env.nodeEnv === 'development',
  maxSize: false,
});

/** Restore the persisted cache from disk. Awaited during app bootstrap. */
export const restoreApolloCache = () => cachePersistor.restore();
